<div class="contract-details-view-container" *ngIf="contractObject" fxLayout="column" fxLayoutGap="15px">
  <div class="id-info">
    <mat-form-field appearance="fill" color="accent">
      <mat-label>ID</mat-label>
      <input matInput placeholder="ID" [disabled]="true" [value]="contractObject.recordId?.toString()">
    </mat-form-field>
  </div>

  <div class="status-info">
    <mat-form-field appearance="fill" [ngClass]="'input-color-' + contractObject.status.color">
      <mat-label>Status</mat-label>
      <input matInput placeholder="Status" [disabled]="true" [value]="contractObject.status?.name">
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutGap="15px">
    <button [disabled]="!(userPermissions | async).contract.write || editBlock" (click)="modify()" mat-stroked-button
            color="primary">
      <mat-icon>create</mat-icon>
      <span> Edytuj</span></button>
    <!--    <button [disabled]="!(userPermissions | async).contract.delete" (click)="delete()" mat-stroked-button color="warn"><mat-icon>delete</mat-icon> <span> Usuń</span></button>-->
    <button *ngIf="contractObject.status.key === CONTRACT_STATUS_ACTIVE"
            [disabled]="!(userPermissions | async).contract.create" (click)="terminate()" mat-stroked-button
            color="warn">
      <mat-icon>content_paste_off</mat-icon>
      <span> Do rozwiązania</span></button>

    <button [class.spinner]="generatingDocument"
            [disabled]="!(userPermissions | async).contract.read || generatingDocument" mat-stroked-button
            [matMenuTriggerFor]="generate">
      <mat-icon>content_copy</mat-icon>
      Wygeneruj
    </button>

    <button
      *ngIf="(userPermissions | async).settlement.admin_root && contractObject.automaticBilling && (contractObject.type?.key === CONTRACT_TYPE_SELF_BILLING || contractObject.type?.key === CONTRACT_TYPE_PARTNERSHIP  || contractObject.type?.key === CONTRACT_TYPE_PROFIT)"
      mat-stroked-button
      [matMenuTriggerFor]="invoiceNumber" aria-label="Menu" color="primary">
      <mat-icon>settings</mat-icon>
    </button>
    <mat-menu #invoiceNumber="matMenu">
      <button
        [disabled]="!(userPermissions | async).settlement.admin_root "
        (click)="invoiceNumberEdit()"
        mat-menu-item
      >
        <mat-icon>edit</mat-icon>
        <span> Zmiana nr faktury</span></button>

    </mat-menu>
    <mat-menu #generate="matMenu">
      <button mat-menu-item (click)="generateContract()">Umowa</button>
      <button
        mat-menu-item (click)="generateAnnexCommissionAttachment()"
        [disabled]="!REGISTRATION_CONTRACT_TYPES.includes(contractObject?.type?.key)"
      >Aneks - załącznik prowizyjny
      </button>
      <button
        mat-menu-item (click)="generateAnnex()"
        [disabled]="CONTRACT_TYPE_SELF_BILLING!==contractObject?.type?.key"
      >Aneks
      </button>
      <button
        *ngIf="[
              CONTRACT_TYPE_PROFIT,
              CONTRACT_TYPE_PARTNERSHIP,
              CONTRACT_TYPE_OCK,
              CONTRACT_TYPE_SELF_BILLING,
            ].includes(contractObject?.type?.key)"
        mat-menu-item (click)="generateAnnexNewContractAttachment()"
        [disabled]="!(userPermissions | async).contract.delete"
      >Aneks - nowy wzór umowy
      </button>
      <button
        *ngIf="[
              CONTRACT_TYPE_PROFIT,
              CONTRACT_TYPE_PARTNERSHIP,
            ].includes(contractObject?.type?.key)"
        mat-menu-item (click)="generateAnnexAutomaticBiling()"
        [disabled]="!(userPermissions | async).contract.delete"
      >Aneks - automatyczne rozliczanie
      </button>
      <button
        *ngIf="[
              CONTRACT_TYPE_PROFIT,
              CONTRACT_TYPE_PARTNERSHIP,
            ].includes(contractObject?.type?.key)"
        mat-menu-item (click)="generateAnnexNewContractAndAutomaticBiling()"
        [disabled]="!(userPermissions | async).contract.delete"
      >Aneks nowy wzór umowy + automatyczne rozliczanie
      </button>
      <button
        mat-menu-item (click)="generateAnnexLead()"
        [disabled]="CONTRACT_TYPE_PARTNERSHIP!==contractObject?.type?.key || !(userPermissions | async).contract.delete "
      >Aneks - załącznik lead
      </button>
      <button mat-menu-item (click)="generateTermination()">Wypowiedzenie</button>
    </mat-menu>
  </div>
  <div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap="15px">

    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">

      <div fxLayout="row" fxFlex.lt-md="100%">
        <div fxFlex="100">
          <mat-card class="partners-add-card">
            <div fxLayout="row">
              <h3>Dane umowy</h3>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="50">
                <app-detail header="Rodzaj umowy" [value]="contractObject.type?.name"></app-detail>
              </div>

              <div fxFlex="50">
                <app-detail header="Data zawarcia" [value]="contractObject.concludeDate | date:'y-MM-dd'"></app-detail>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="50">
                <app-detail header="Firma" [value]="contractObject.company?.name"></app-detail>
              </div>

              <div fxFlex="50">
                <app-detail header="Numer" [value]="contractObject.number"></app-detail>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="50">
                <app-detail header="Aktywna od" [value]="contractObject.activeFrom | date:'y-MM-dd'"></app-detail>
              </div>

              <div fxFlex="50">
                <app-detail header="Data zakończenia" [value]="contractObject.activeTo | date:'y-MM-dd'"></app-detail>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Czas trwania" [value]="contractObject.period?.name"></app-detail>
              </div>
            </div>

            <ng-container *ngIf="contractObject.terminationTime || contractObject.terminationType">
              <div fxLayout="row" fxLayoutGap="15px">
                <div fxFlex="50">
                  <app-detail header="Sposób rozwiązania" [value]="contractObject.terminationType?.name"></app-detail>
                </div>

                <div fxFlex="50">
                  <app-detail header="Okres wypowiedzenia" [value]="contractObject.terminationTime?.name"></app-detail>
                </div>
              </div>
            </ng-container>

            <ng-container *ngIf="contractObject.cancellationReason">
              <div fxLayout="row" fxLayoutGap="15px">
                <div fxFlex="100">
                  <app-detail header="Powód anulowania" [value]="contractObject.cancellationReason?.name"></app-detail>
                </div>
              </div>

              <div fxLayout="row">
                <div fxFlex="100">
                  <app-detail header="Wyjaśnienie anulowania"
                              [value]="contractObject.cancellationExplanation"></app-detail>
                </div>
              </div>
            </ng-container>

            <ng-container *ngIf="[
              CONTRACT_STATUS_DURING_TERMINATION,
              CONTRACT_STATUS_TERMINATED,
              CONTRACT_STATUS_TO_TERMINATE,
              CONTRACT_STATUS_CLOSED,
            ].includes(contractObject?.status?.key)">
              <div fxLayout="row">
                <div fxFlex="100">
                  <app-detail header="Powód rozwiązania" [value]="contractObject.terminationReason"></app-detail>
                </div>
              </div>
            </ng-container>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail-bool header="Rekord zweryfikowany" [value]="contractObject.verified"></app-detail-bool>
              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="15px" *ngIf=" contractObject.type.key === CONTRACT_TYPE_PARTNERSHIP">
              <div fxFlex="100">
                <app-detail-bool header="Stawki niestandardowe" [value]="contractObject.customRates"></app-detail-bool>
              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="15px" *ngIf=" contractObject.type.key === CONTRACT_TYPE_PARTNERSHIP">
              <div fxFlex="100">
                <app-detail header="Partner, z którego przepisujemy umowę"
                            [value]="contractObject.assignedPartner?.shortName"></app-detail>
              </div>
            </div>
            <!--            <ng-container *ngIf="![-->
            <!--              CONTRACT_TYPE_AGREEMENT_FOR_PARTNER_POINTS,-->
            <!--              CONTRACT_TYPE_FRANCHISE_AGREEMENT,-->
            <!--              CONTRACT_TYPE_FRANCHISE-->
            <!--            ].includes(contractObject?.type?.key)">-->
            <!--            <div fxLayout="row" fxLayoutGap="15px">-->
            <!--              <div fxFlex="100">-->
            <!--                <app-detail-bool header="Aktualne zgłoszenie" [value]="contractObject.signedCurrentApplications"></app-detail-bool>-->
            <!--              </div>-->
            <!--            </div>-->
            <!--            </ng-container>-->
            <ng-container
              *ngIf="(userPermissions | async).contract.admin_root && (contractObject.type.key === CONTRACT_TYPE_SELF_BILLING || contractObject.type.key === CONTRACT_TYPE_PARTNERSHIP || contractObject.type.key === CONTRACT_TYPE_PROFIT)">
              <div fxLayout="row" fxLayoutGap="15px">
                <div fxFlex="100">
                  <app-detail-bool header="Miesiąc sprzedaży aktualny"
                                   [value]="contractObject.invoiceServiceDate"></app-detail-bool>
                </div>
              </div>
              <div fxLayout="row" fxLayoutGap="15px">
                <div fxFlex="100" fxLayout="row" fxLayoutGap="15px">
                  <app-detail-bool
                    [header]="'Oczekuje ' + (contractObject.selfBillingExpects ? '(' + ((contractObject.selfBillingExpects) | date:'y-MM-dd') + ')' : '') "
                    [value]="contractObject.selfBillingExpects ? true : false"></app-detail-bool>
                </div>
              </div>
            </ng-container>

            <ng-container *ngIf="[
              CONTRACT_TYPE_PARTNERSHIP , CONTRACT_TYPE_PROFIT , CONTRACT_TYPE_OCK, CONTRACT_TYPE_SELF_BILLING
            ].includes(contractObject?.type?.key)">
              <div fxLayout="row" fxLayoutGap="15px">
                <div fxFlex="100">
                  <app-detail-bool header="Nowy wzór umowy"
                                   [value]="contractObject.newContractTemplate"></app-detail-bool>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="[
              CONTRACT_TYPE_PARTNERSHIP , CONTRACT_TYPE_PROFIT
            ].includes(contractObject?.type?.key)">
              <div fxLayout="row" fxLayoutGap="15px">
                <div fxFlex="100">
                  <app-detail-bool header="Automatyczne rozliczanie"
                                   [value]="contractObject.automaticBilling"></app-detail-bool>
                </div>
              </div>
            </ng-container>

            <ng-container *ngIf="[
              CONTRACT_TYPE_PARTNERSHIP, CONTRACT_TYPE_PROFIT, CONTRACT_TYPE_MANDATE, CONTRACT_TYPE_MANDATE_ONLY_HEALTH,
              CONTRACT_TYPE_MANDATE_COMPLETE_PACKAGE
            ].includes(contractObject?.type?.key)">
              <div fxLayout="row" fxLayoutGap="15px">
                <div fxFlex="100">
                  <app-detail-bool header="Niestandardowe zapisy w umowie"
                                   [value]="contractObject.customTerms"></app-detail-bool>
                </div>
              </div>
            </ng-container>

          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100%"
           *ngIf="contractObject?.type?.key === CONTRACT_TYPE_SELF_BILLING || contractObject?.type?.key === CONTRACT_TYPE_PARTNERSHIP || contractObject?.type?.key === CONTRACT_TYPE_PROFIT">
        <div fxFlex="100">
          <mat-card class="partners-add-card">
            <div fxLayout="row">
              <ng-container *ngIf="contractObject?.type?.key === CONTRACT_TYPE_SELF_BILLING">
                <h3>Dane umowy na samofakturowanie</h3>
              </ng-container>
              <ng-container
                *ngIf="contractObject?.type?.key === CONTRACT_TYPE_PARTNERSHIP || contractObject?.type?.key === CONTRACT_TYPE_PROFIT">
                <h3>Dane do zestawienia prowizyjnego</h3>
              </ng-container>
            </div>

            <div fxLayout="row">
              <div fxFlex="100">
                <app-detail header="Email" [value]="contractObject.selfBillingEmail"></app-detail>
              </div>
            </div>

            <div fxLayout="row">
              <div fxFlex="100">
                <app-detail header="Numer telefonu" [value]="contractObject.selfBillingPhone"></app-detail>
              </div>
            </div>

            <div fxLayout="row">
              <div fxFlex="100">
                <app-detail header="Numer rachunku bankowego"
                            [value]="contractObject.selfBillingAccountNumber"></app-detail>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px" *ngIf="contractObject?.type?.key === CONTRACT_TYPE_SELF_BILLING">
              <div fxFlex="100">
                <app-detail-bool header="Zarejestrowany jako płatnik VAT"
                                 [value]="contractObject.selfBillingVatPayer"></app-detail-bool>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px" *ngIf="contractObject?.type?.key === CONTRACT_TYPE_SELF_BILLING">
              <div fxFlex="100">
                <app-detail-bool header="Płatnik VAT czynny"
                                 [value]="contractObject.selfBillingActiveVatPayer"></app-detail-bool>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px" *ngIf="contractObject?.type?.key === CONTRACT_TYPE_SELF_BILLING">
              <div fxFlex="100">
                <app-detail-bool header="Metoda kasowa"
                                 [value]="contractObject.selfBillingCheckoutMethod"></app-detail-bool>
              </div>
            </div>

          </mat-card>
        </div>
      </div>

    </div>

    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">

      <div fxLayout="row" fxFlex.lt-md="100%">
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>Relacje</h3>
            </div>

            <div fxLayout="row">
              <app-detail fxFlex="100" header="Strona umowy" [value]="contractObject.owner?.name"></app-detail>
            </div>

            <ng-container *ngIf="contractObject.partner">
              <div fxLayout="row">
                <app-detail fxFlex="100" header="Partner" [value]="contractObject.partner?.shortName"
                            [link]="['/partnerzy/szczegoly', contractObject.partner?.uuid]"></app-detail>
              </div>

              <div fxLayout="row">
                <app-detail fxFlex="100" header="Tagi partnera">
                  <mat-chip-list>
                    <ng-container *ngFor="let tag of contractObject.partner.tags; let last = last">
                      <mat-chip color="accent" selected>{{ tag.name }}</mat-chip>
                    </ng-container>
                  </mat-chip-list>
                </app-detail>
              </div>

              <div fxLayout="row">
                <app-detail fxFlex="100" header="Regionalny (majątek)"
                            [value]="contractObject.partner.assetsRegional ? contractObject.partner.assetsRegional?.fullName : 'Brak'"></app-detail>
              </div>
            </ng-container>

            <ng-container *ngIf="contractObject.ofwca">
              <div fxLayout="row">
                <app-detail fxFlex="100" header="OFWCA" [value]="contractObject.ofwca?.fullName"
                            [link]="['/ofwca/szczegoly', contractObject.ofwca?.uuid]"></app-detail>
              </div>

              <div fxLayout="row">
                <app-detail fxFlex="100" header="Regionalny (majątek)"
                            [value]="contractObject.ofwca.assetsRegional ? contractObject.ofwca.assetsRegional?.fullName : 'Brak'"></app-detail>
              </div>
            </ng-container>

            <div fxLayout="row" *ngIf="contractObject.parentContract">
              <div fxFlex="100">
                <app-detail header="Umowa Współpracy"
                            [value]="contractObject.parentContract.type.name + ' (nr: ' + contractObject.parentContract.number + '), zawarta ' + (contractObject.parentContract.concludeDate | date:'y-MM-dd')"
                            [link]="contractObject.parentContract ? ['/umowy/szczegoly', contractObject.parentContract.uuid] : undefined">
                </app-detail>
              </div>
            </div>
            <div fxLayout="row" *ngIf="contractObject.facility">
              <div fxFlex="100">
                <app-detail header="Placówka" [value]="contractObject.facility?.address?.searchString"
                            [link]="contractObject.facility ? ['/placowki/szczegoly', contractObject.facility?.address?.uuid] : undefined"></app-detail>
              </div>
            </div>


          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100%" *ngIf="COMMISSION_STATEMENT_GENERATION_CRITERIA_TYPE.includes(contractObject?.type?.key)">
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>Tabela prowizyjna</h3>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Tabela prowizyjna">
                  {{ contractObject?.commissionTable?.shortName }} - {{ contractObject?.commissionTable?.name }}<br>
                  <span style="font-size: 14px" *ngIf="contractObject?.commissionTable">
                    Obowiązuje: {{ contractObject?.commissionTable?.validFrom | date:'y-MM-dd' }} -
                    {{ contractObject?.commissionTable?.validTo
                        ? (contractObject?.commissionTable?.validTo | date:'y-MM-dd')
                        : 'bezterminowo'
                    }}
                  </span>

                </app-detail>
              </div>
            </div>

          </mat-card>
        </div>
      </div>
      <div fxLayout="row" fxFlex.lt-md="100%">
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>Uwagi</h3>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="" [value]="contractObject.note"></app-detail>
              </div>
            </div>

          </mat-card>
        </div>
      </div>

    </div>

  </div>
</div>
